import { render } from "./TransitionWrapper.vue?vue&type=template&id=626c1042"
import script from "./TransitionWrapper.vue?vue&type=script&lang=js"
export * from "./TransitionWrapper.vue?vue&type=script&lang=js"

import "./TransitionWrapper.vue?vue&type=style&index=0&id=626c1042&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__